<sm-overlay [backdropActive]="backdropActive$|async"></sm-overlay>
<mat-sidenav-container *ngIf="!minimized; else content">
  <mat-sidenav mode="side" opened>
    <mat-nav-list dense>
      <a mat-list-item
         class="side-link"
         [class.selected]="link === currentLink"
         (click)="showSection(link)"
         *ngFor="let link of links">{{ link | uppercase }}</a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #content>
  <ng-template #template
    let-saving="saving" let-editable="editable" let-showExtraDataSpinner="showExtraDataSpinner" let-isInDev="isInDev"
    [ngTemplateOutletContext]="{ saving: saving$ | async,
                                 editable: editable$ | async,
                                 showExtraDataSpinner: showExtraDataSpinner$ | async,
                                 isInDev: isInDev$ | async
                               }" [ngTemplateOutlet]="template">
    <div class="sidenav-content" [class.maximized]="!minimized" *ngIf="formData">
    <sm-editable-section #sourceSection
                         class="limit-width"
                         *ngIf="minimized || currentLink === 'details'"
                         [saving]="saving"
                         [editable]="editable"
                         (cancelClicked)="cancelFormChange()"
                         (saveClicked)="sourceCode.sourceCodeForm.valid? saveSourceData(): sourceCode.sourceCodeForm.onSubmit(null)"
                         (activateEditClicked)="activateEditChanged('source', sourceSection)">
      <sm-section-header label="SOURCE CODE"></sm-section-header>
      <sm-experiment-execution-source-code
        #sourceCode
        class="form-section"
        [editable]="(editable && !isInDev) && sourceSection.inEditMode"
        [formData]="formData.source"
      ></sm-experiment-execution-source-code>
    </sm-editable-section>

    <sm-editable-section #diffSection
                         class="grow"
                         *ngIf="minimized || currentLink === 'uncommitted changes'"
                         [saving]="saving"
                         [editable]="editable && !showExtraDataSpinner"
                         [hideEditButton]="!!formData.diff"
                         [disableInEditMode]="true"
                         (cancelClicked)="cancelFormChange()"
                         (activateEditClicked)="activateEditChanged('diff'); editDiff()">
      <sm-section-header *ngIf="minimized" label="UNCOMMITTED CHANGES"></sm-section-header>
      <sm-scroll-textarea
        class="form-section"
        [editable]="editable && diffSection.inEditMode"
        [isInDev]="isInDev"
        [formData]="formData.diff"
        [showSpinner]="showExtraDataSpinner"
      >
        <button extra-buttons
                *ngIf="formData.diff && editable && !showExtraDataSpinner"
                class="btn-dark-fill terminal mr-3 flex-1"
                (click)="diffSection.editModeChanged(true)">EDIT</button>
        <button extra-buttons
                *ngIf="formData.diff && editable && !showExtraDataSpinner"
                class="btn-dark-fill terminal mr-3 flex-1"
                (click)="discardDiff()">
          DISCARD DIFFS
        </button>
      </sm-scroll-textarea>
    </sm-editable-section>

    <sm-editable-section #requirementsSection
                         class="grow"
                         *ngIf="minimized || currentLink === 'installed packages'"
                         [saving]="saving"
                         [editable]="editable"
                         [disableInEditMode]="true"
                         [disableSave]="false"
                         [hideEditButton]="!!formData?.requirements?.pip"
                         (cancelClicked)="cancelFormChange()"
                         (activateEditClicked)="activateEditChanged('source'); editInstallPackages()">
      <sm-section-header *ngIf="minimized" label="INSTALLED PACKAGES"></sm-section-header>
      <sm-scroll-textarea
        class="form-section"
        emptyMessage="Packages will be installed from projects requirements file"
        [editable]="editable && requirementsSection.inEditMode"
        [isInDev]="isInDev"
        [formData]="formData.requirements?.pip">
        <button extra-buttons
                *ngIf="formData?.requirements?.pip && editable && !showExtraDataSpinner"
                class="btn-dark-fill terminal mr-3 flex-1"
                (click)="requirementsSection.editModeChanged(true)">EDIT</button>
        <button extra-buttons
                *ngIf="formData.requirements?.pip && editable && !showExtraDataSpinner"
                class="btn-dark-fill terminal mr-3 flex-1"
                (click)="clearInstalledPackages()">
          CLEAR
        </button>
      </sm-scroll-textarea>
    </sm-editable-section>
    <sm-editable-section #containerSection
                         class="limit-width edit-in-section"
                         [style.margin-bottom.px]="containerSection.inEditMode ? 30 : null"
                         *ngIf="minimized || currentLink === 'container'"
                         [saving]="saving"
                         [editable]="editable"
                         (cancelClicked)="cancelFormChange()"
                         (saveClicked)="saveContainerData({image: containerImage.nativeElement.value, arguments: containerArguments.nativeElement.value})"
                         (activateEditClicked)="activateEditChanged('orchestration', containerSection)">
      <sm-section-header label="CONTAINER"></sm-section-header>
      <sm-labeled-row label="IMAGE" [class.mb-3]="editable">
        <div *ngIf="!((editable && !isInDev) && containerSection.inEditMode)">{{formData.container?.image}}</div>
        <mat-form-field appearance="outline" *ngIf="(editable && !isInDev) && containerSection.inEditMode" class="col-24">
          <input #containerImage matInput [ngModel]="formData.container?.image" name="image">
        </mat-form-field>
      </sm-labeled-row>
      <sm-labeled-row label="ARGUMENTS" [class.mb-3]="editable" [labelClass]="'this-is-myclass'">
        <div *ngIf="!((editable && !isInDev) && containerSection.inEditMode)">{{formData.container?.arguments | hideRedactedArguments: (redactedArguments$| async) }}</div>
        <mat-form-field appearance="outline" *ngIf="(editable && !isInDev) && containerSection.inEditMode" class="col-24">
          <input #containerArguments matInput [ngModel]="formData.container?.arguments" name="image">
        </mat-form-field>
      </sm-labeled-row>

    </sm-editable-section>
        <sm-editable-section #containerSetupShellSection
                             class="grow setup-shell-script"
                             [class.maximised]="!minimized"
                             [class.mb-3]="editable"
                             *ngIf="minimized || currentLink === 'container'"
                             [saving]="saving"
                             [editable]="editable && (!(formData?.container?.setup_shell_script) || containerSetupShellSection.inEditMode)"
                             [disableInEditMode]="true"
                             [disableSave]="false"
                             (cancelClicked)="cancelFormChange()"
                             (activateEditClicked)="activateEditChanged('container'); editContainerSetupShellScript(containerSetupShellSection)">
          <sm-section-header  label="SETUP SHELL SCRIPT"></sm-section-header>
          <sm-scroll-textarea
            class="form-section"
            [editable]="editable && containerSetupShellSection.inEditMode"
            [isInDev]="isInDev"
            [formData]="formData?.container?.setup_shell_script">
            <button extra-buttons
                    *ngIf="formData?.container?.setup_shell_script && editable && !showExtraDataSpinner"
                    class="btn-dark-fill terminal mr-3 flex-1"
                    (click)="containerSetupShellSection.editModeChanged(true)">EDIT</button>
            <button extra-buttons
                    *ngIf="formData.container?.setup_shell_script && editable && !showExtraDataSpinner"
                    class="btn-dark-fill terminal mr-3 flex-1"
                    (click)="clearSetupShellScript()">
              CLEAR
            </button>
          </sm-scroll-textarea>
        </sm-editable-section>

    <sm-editable-section #outputSection
                         class="limit-width"
                         *ngIf="minimized || currentLink === 'details'"
                         [saving]="saving"
                         [editable]="editable"
                         (cancelClicked)="cancelFormChange()"
                         (saveClicked)="saveOutputData()"
                         (activateEditClicked)="activateEditChanged('output', outputSection)">
      <sm-section-header label="OUTPUT"></sm-section-header>
      <sm-labeled-row label="DESTINATION">
        <div *ngIf="!((editable && !isInDev) && outputSection.inEditMode)">{{formData.output?.destination}}</div>
        <mat-form-field appearance="outline" *ngIf="editable && outputSection.inEditMode" class="col-24">
          <input #outputDestination matInput [ngModel]="formData.output?.destination" name="output_destination">
        </mat-form-field>
      </sm-labeled-row>
      <!--      Can we remove this non existing input?-->
      <sm-labeled-row label="LOG LEVEL" [class.mb-3]="editable">
        <div *ngIf="!((editable && !isInDev) && outputSection.inEditMode)">{{formData.output?.logLevel}}</div>
        <mat-form-field appearance="outline" *ngIf="editable && outputSection.inEditMode" class="col-24">
          <input #outputLogLevel matInput [ngModel]="formData.output?.logLevel" name="output_destination">
        </mat-form-field>
      </sm-labeled-row>
    </sm-editable-section>
  </div>
  </ng-template>
</ng-template>
